import { nanoid } from 'nanoid';
import { downloadFile } from '../../../utils/functions';

const init = ({ pieces, setWorkers }) => {
  let worker;
  if(pieces.version===2)
    worker = new Worker(new URL('./worker-v2.js', import.meta.url));
  else
    worker = new Worker(new URL('./worker.js', import.meta.url));

  let newId = nanoid();

  worker.postMessage({ data: pieces.content, types: pieces.types  });
  worker.onerror = (err) => err;
  worker.onmessage = (e) => {
    const { status, dataUrl } = e.data;

    setWorkers((prev) => {
      const updatedWorkers = {...prev};
      updatedWorkers[newId].data = e.data;
      return updatedWorkers;
    });

    if(status === 'finished') {
      downloadFile(dataUrl, `${pieces.filename}.xlsx`, false);
      worker.terminate();
    }
  };
  
  setWorkers((prev) => ({ ...prev, 
    [newId]: { 
      worker, 
      type: 'excel', 
      name: pieces.name,
      filename: pieces.filename, 
      data: { status: 'starting', progress: 0 }
    }
  }));

}

export default init;